export const BLUE_010 = '#EFF7FD';

export const BLUE_020 = '#D2DDE4';

export const BLUE_030 = '#2E90B7';

export const BLUE_040 = '#10567B';

export const BLUE_050 = '#064162';

export const BLUE_060 = '#003354';

export const SALMON_010 = '#FFF8F7';

export const SALMON_020 = '#F5B3AE';

export const SALMON_030 = '#EE847D';

export const SALMON_040 = '#F16C5D';

export const SALMON_050 = '#E56051';

export const SALMON_060 = '#DA5648';

export const AQUA_010 = '#D7ECFF';

export const AQUA_020 = '#ACD7FF';

export const AQUA_030 = '#6BAFFF';

export const AQUA_040 = '#1588F4';

export const AQUA_050 = '#006ED5';

export const AQUA_060 = '#2E6DBE';

export const GREEN_010 = '#E5F7F4';

export const GREEN_020 = '#98DDD2';

export const GREEN_030 = '#53C6B4';

export const GREEN_040 = '#30BBA5';

export const GREEN_050 = '#2CAC97';

export const GREEN_060 = '#289C8A';

export const RED_010 = '#FFE9EC';

export const RED_020 = '#FF9EAA';

export const RED_030 = '#F86173';

export const RED_040 = '#E63349';

export const RED_050 = '#D7213E';

export const RED_060 = '#C41428';

export const YELLOW_010 = '#FEF8EA';

export const YELLOW_020 = '#FFEDAF';

export const YELLOW_030 = '#FFDE71';

export const YELLOW_040 = '#FACB4D';

export const YELLOW_050 = '#F7BD2B';

export const YELLOW_060 = '#EFAE09';

export const GRAY_010 = '#F7F7F8';

export const GRAY_020 = '#EEEEEF';

export const GRAY_030 = '#E5E5E5';

export const GRAY_040 = '#D3D3D5';

export const GRAY_050 = '#BFBFC1';

export const GRAY_060 = '#A8A8AB';

export const GRAY_070 = '#929295';

export const GRAY_080 = '#7C7C80';

export const GRAY_090 = '#66666A';

export const GRAY_100 = '#515156';

export const GRAY_110 = '#45454A';

export const GRAY_120 = '#39393E';

export const GRAY_130 = '#202026';

export const GRAY_000 = '#FFFFFF';

export const PURPLE_010 = '#F5F2FF';

export const PURPLE_020 = '#DECFFF';

export const PURPLE_030 = '#CEB7FF';

export const PURPLE_040 = '#B38FFF';

export const PURPLE_050 = '#874FFE';

export const PURPLE_060 = '#6821FF';

export const GRAY_CLEAR = 'transparent';

const BasicColor = {
    BLUE_010,
    BLUE_020,
    BLUE_030,
    BLUE_040,
    BLUE_050,
    BLUE_060,
    SALMON_010,
    SALMON_020,
    SALMON_030,
    SALMON_040,
    SALMON_050,
    SALMON_060,
    AQUA_010,
    AQUA_020,
    AQUA_030,
    AQUA_040,
    AQUA_050,
    AQUA_060,
    GREEN_010,
    GREEN_020,
    GREEN_030,
    GREEN_040,
    GREEN_050,
    GREEN_060,
    RED_010,
    RED_020,
    RED_030,
    RED_040,
    RED_050,
    RED_060,
    YELLOW_010,
    YELLOW_020,
    YELLOW_030,
    YELLOW_040,
    YELLOW_050,
    YELLOW_060,
    GRAY_010,
    GRAY_020,
    GRAY_030,
    GRAY_040,
    GRAY_050,
    GRAY_060,
    GRAY_070,
    GRAY_080,
    GRAY_090,
    GRAY_100,
    GRAY_110,
    GRAY_120,
    GRAY_130,
    GRAY_000,
    GRAY_CLEAR,
    PURPLE_010,
    PURPLE_020,
    PURPLE_030,
    PURPLE_040,
    PURPLE_050,
    PURPLE_060,
};

export default BasicColor;
